<div class="center">
  <ng-container *ngIf="!files.length">
    <ngx-file-drop
      dropZoneLabel="Drop files here"
      [accept]="type === 'audio' ? 'audio/*' : 'video/*'"
      (onFileDrop)="dropped($event)"
      [multiple]="false"
    >
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        Drag you file here or
        <button type="button" class="btn btn-secondary btn-sm ml-2" (click)="openFileSelector()">
          Select file
        </button>
      </ng-template>
    </ngx-file-drop>
  </ng-container>
  <div class="upload-table" *ngIf="files.length">
    <table class="table d-flex justify-content-center">
      <tbody class="upload-name-style">
        <tr *ngFor="let item of files; let i = index">
          <td>
            <span [title]="item.relativePath"
              >{{
                item.relativePath.length > 25
                  ? (item.relativePath | slice : 0 : 25) + '...'
                  : item.relativePath
              }}
              ({{ fileSize }})</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p *ngIf="fileErrorMessage" class="text-danger m-0">{{ fileErrorMessage }}</p>

  <div *ngIf="files.length" class="d-flex justify-content-center">
    <button (click)="clearDroppedFiles()" class="btn btn-danger btn-sm">Clear</button>
    <!-- <button class="btn btn-success btn-sm ml-2">Upload</button> -->
  </div>
</div>
